import { FC } from 'react';
import { Banner, BannerVariant } from 'components/Banner';
import Typography from 'components/Typography/Typography';
import { useTranslation } from 'react-i18next';
import { FREE_DELIVERY_INFO_TEST_ID } from 'components/FreeDeliveryInfo.const';
import { useDeliveryPlacementConditions } from 'hooks/useDeliveryPlacementConditions';
import { useServiceType } from 'hooks/context/serviceType';

type FreeDeliveryInfoProps = {
  className?: string;
};

export const FreeDeliveryInfo: FC<FreeDeliveryInfoProps> = ({ className }) => {
  const { t } = useTranslation();
  const { isFreeDelivery, isBelowMinimumDeliveryAmount } = useDeliveryPlacementConditions();
  const { isDelivery } = useServiceType();

  return (
    <>
      {isDelivery && !isBelowMinimumDeliveryAmount && isFreeDelivery && (
        <Banner
          variant={BannerVariant.INFO}
          className={className}
          rounded={true}
          aria-live={'polite'}
          data-testid={FREE_DELIVERY_INFO_TEST_ID.free}
        >
          <Typography.Body bold>{t('deliveryBanner.isRemoved')}</Typography.Body>
        </Banner>
      )}
    </>
  );
};
